// Antes de pintar una pantalla que depende de los permisos: loader mientras llega el perfil y
// «Reintentar» si no se pudo leer. Nunca concluye «sin acceso» sin perfil.
import { type ReactNode } from 'react';
import { useRouter } from '@tanstack/react-router';
import { Loading } from '@/kit';
import { useAuth } from '@/hooks/useAuth';
import { PortalProfileUnavailable } from './PortalProfileUnavailable';

export function ProfileGate({ children }: { children: ReactNode }) {
    const { loading, error, refresh, user } = useAuth();
    const router = useRouter();
    if (loading && !user) return <Loading size="lg" fullScreen text="Cargando tu perfil…" />;
    if (error && !user) {
        return (
            <PortalProfileUnavailable
                onRetry={() => {
                    // Tras releer el perfil se vuelven a correr los guards de la ruta.
                    void refresh().then(() => router.invalidate());
                }}
            />
        );
    }
    return <>{children}</>;
}
